// extracted by mini-css-extract-plugin
export default {"input":"FormInput_input__1lWN8"};